import RoutesMap from "route_control/RouteControl"
import { Notifications } from "pages/notifications"

const NotificationsRoute = () => {
    return [
        {
            path: RoutesMap.NOTIFICATIONS.path,
            element: <Notifications />
        }
    ]
}

export default NotificationsRoute;